<div class="company-nztable-data-grid">
  <company-nztable-bridge />
  <ng-content />
</div>
